import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { updateProfile } from "../../../../actions/sessionActions";
import { objToFormData } from "../../../../helpers/FormHelper";

import DrawerRight from "../../../../componets/DrawerRight";
import AlertBlock from "../../../../componets/AlertBlock";
import FileDropzone from "../../../../componets/FileDropzone";
import { Button, Form, Input } from 'antd';

interface propsInterface {
  open: boolean;
  onClose: () => void;
}

const ProfileEdit = ({ open, onClose }: propsInterface) => {
  const dispatch = useAppDispatch();
  const admin = useAppSelector(state => state.session.admin);
  const [error, setError] = useState<string | null>(null);
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
      setError(null);
    }
  }, [open, admin, form]);

  function onFinish(values: object) {
    handleSave(values).catch(console.error);
  }

  async function handleSave(values: object) {
    const resultAction = await dispatch(updateProfile(objToFormData(values)));

    if (updateProfile.fulfilled.match(resultAction)) {
      onClose();
    } else {
      const payload: any = resultAction.payload;
      const errors = payload?.errors || payload;
      setError(Array.isArray(errors) ? errors[0] : 'Failed to update profile');
    }
  }

  return (
    <DrawerRight
      open={open}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-profile'>
        <h6 className="v-content-label">Edit Profile</h6>

        <AlertBlock type='error' message={error} onClose={() => setError(null)} />

        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          className='v-form'
          initialValues={{ username: admin.username, email: admin.email }}
        >
          <FileDropzone name='avatar' label='Avatar' preview={admin.avatar_url || undefined} />

          <Form.Item name='username' label="Username" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name='email' label="Email" rules={[{ required: true }, { type: 'email' }]}>
            <Input />
          </Form.Item>

          <Form.Item name='password' label="New Password (leave blank to keep current)">
            <Input.Password autoComplete='new-password' />
          </Form.Item>

          <Form.Item
            name='old_password'
            label="Current Password"
            dependencies={['password']}
            rules={[
              ({ getFieldValue }) => ({
                required: !!getFieldValue('password'),
                message: 'Current password is required to change your password'
              })
            ]}
          >
            <Input.Password autoComplete='current-password' />
          </Form.Item>

          <Form.Item>
            <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </DrawerRight>
  )
}

export default ProfileEdit;
